"use strict";
exports.__esModule = true;
exports.TranslationType = void 0;
var TranslationType;
(function (TranslationType) {
    TranslationType["Translation"] = "translation";
})(TranslationType = exports.TranslationType || (exports.TranslationType = {}));
//# sourceMappingURL=translation.js.map